import { steps, PrimaryFlowSteps, StepDef } from "./flowSteps";
import { FlowContext } from "./flowContext";

export const flowResolver = {
    /**
     * Find the current step by walking the flow graph
     * Returns first step where isReady is true
     */
    current(c: FlowContext): PrimaryFlowSteps {
        // Walk graph from purpose, find first ready step
        const visited = new Set<PrimaryFlowSteps>();
        let step: PrimaryFlowSteps = "purpose";

        while (!visited.has(step)) {
            visited.add(step);
            const def: StepDef | undefined = steps[step];

            if (!def) {
                break;
            }
            if (def.isReady(c)) {
                return step;
            }

            const next: PrimaryFlowSteps | null = def.next(c);
            if (!next) {
                break;
            }
            step = next;
        }

        return "outro"; // Fallback
    },

    /**
     * Get next step from current
     */
    next(current: PrimaryFlowSteps, c: FlowContext): PrimaryFlowSteps | null {
        return steps[current]?.next(c) ?? null;
    },

    /**
     * Get previous step (if defined)
     */
    prev(current: PrimaryFlowSteps, c: FlowContext): PrimaryFlowSteps | null {
        return steps[current]?.prev?.(c) ?? null;
    },
};
